import React from "react";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import bodyBuildingData from "./bodyBuildingData";
import SelfCoachingItem from "../SelfCoachingItem/SelfCoachingItem";

export default function BodyBuildingCoaching() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">مربی خودت باش</div>
          <div style={{ marginTop: "1.25rem", width: "100%" }}>
            {bodyBuildingData.map((item) => (
              <SelfCoachingItem key={item.id} {...item} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
